import { GAME_ID, REDUX_ACTIONS, ITEM_TYPES, BACKGROUNDS } from 'a/estaOAquella/data/constants';

const initialState = {
  layout: {},
  dropAnimationStarted: false,
  itemType: ITEM_TYPES.WORD,
  backgroundType: BACKGROUNDS.ICE_CREAM,
};

const displayReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_LAYOUT:
      return {
        ...state,
        dropAnimationStarted: false,
        layout: action.payload.layout,
      };
    case REDUX_ACTIONS.SET_DROP_ANIMATION_STARTED:
      return {
        ...state,
        dropAnimationStarted: action.payload.dropAnimationStarted,
      };
    case REDUX_ACTIONS.SET_ITEM_TYPE:
      return {
        ...state,
        itemType: action.payload,
      };
    case REDUX_ACTIONS.SET_BACKGROUND_TYPE:
      return {
        ...state,
        backgroundType: action.payload,
      };
    default:
      return state;
  }
};

export default displayReducer;
